<!DOCTYPE html>
<html lang="en" *ngIf="route.children.length === 0">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">

</head>

<body>
  <div class="container white_bg body_min_height">
    <div class="PageTitle">
      <h3 id="title" style="text-align: center;"><b>Setup</b></h3>
    </div>

    <ng-container *ngIf="!lockDown; else lockDownMode">

      <div class="links-grid-container">
        <a *ngIf="permissionHandlingService.siRead" 
          (click)="navigateTo('special instructions'); logNavigation('search special instructions')"
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Special Instructions</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.phRead" 
          (click)="navigateTo('prehold'); logNavigation('Prehold')"
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>PreHold</b></h4>
        </a>

        <!-- TODO: REPLACE PREHOLD PERMISSION WITH OWN PERMISSION -->
        <!-- <a *ngIf="dmRead === 'NOT-ALLOWED'" 
          (click)="navigateTo('delayed mail'); logNavigation('DelayedMail')"
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Delayed Mail</b></h4>
        </a> -->

        <a *ngIf="permissionHandlingService.psRead || psRead === 'travellerSetup'"
          (click)="navigateTo('production setup'); logNavigation('productionSetup')"
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Production Setup</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.ptRead" 
          (click)="navigateTo('plan template'); logNavigation('planTemplate')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Plan Template</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.pmRead" 
          (click)="navigateTo('production method'); logNavigation('productionMethod')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Production Method Group</b></h4>
        </a>

        <!-- <a *ngIf="paRead === 'Inactive'" 
          (click)="navigateTo('package template'); logNavigation('packageTemplate')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Package Template</b></h4>
        </a> -->

        <a *ngIf="permissionHandlingService.csRead" 
          (click)="navigateTo('corp setup'); logNavigation('corpSetup')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Corp Setup</b></h4>
        </a>

        <!-- env === 'dev' || 'QA' -->
        <a *ngIf="permissionHandlingService.rsRead" 
          (click)="navigateTo('rule setup'); logNavigation('ruleSetup')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Rule Setup</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.midWrite" 
          (click)="navigateTo('mailerIdSetup'); logNavigation('mailerIdSetup')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Mailer ID Setup</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.psWrite" 
          (click)="navigateTo('parameterEntry'); logNavigation('parameterEntry')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Parameter Entry</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.pmRead" 
          (click)="navigateTo('perfMeasurements'); logNavigation('perfMeasurements')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Perf Measurements</b></h4>
        </a>

        <a *ngIf="permissionHandlingService.pmRead" 
          (click)="navigateTo('corpProfileSetup'); logNavigation('corpProfileSetup')" 
          class="sm-link sm-link_padding-all sm-link1 styled-links">
          <h4 class="sm-link__label"><b>Corp Profile Setup</b></h4>
        </a>
      </div>

    </ng-container>
    <ng-template #lockDownMode>
      <H1 class="col-md-12 flexbox-center no-wrapping" style="text-align:left;">{{ bannerMessage }}</H1>
      <H1 class="col-md-1 col-md-offset-6 flexbox-center no-wrapping" *ngIf="lockdownMsg">EFS Systems will be available
        October 19th</H1>
      <H1 class="col-md-1 col-md-offset-3 flexbox-center no-wrapping" *ngIf="ieMessage">Please log in through
        Chrome/Firefox Browser</H1>
    </ng-template>


  </div>
</body>

</html>
<router-outlet></router-outlet>